// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_OpenDeductionsForPeriodResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_OpenDeductionsForPeriodResultRow } from './Payroll_OpenDeductionsForPeriodResultRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_OpenDeductionsForPeriodResponseDados = Payroll_OpenDeductionsForPeriodResultRow;

export type Payroll_OpenDeductionsForPeriodResponse = ApiResponse<Payroll_OpenDeductionsForPeriodResponseDados>;

registerResponseContract('Payroll_OpenDeductionsForPeriodResponse', {
  deductions: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      employee_id:      { type: 'string',  required: true },
      franchise_id:     { type: 'number',  required: true },
      title:            { type: 'string',  required: true },
      description:      { type: 'string',  required: false },
      amount:           { type: 'string',  required: true },
      status:           { type: 'number',  required: true },
      amount_paid:      { type: 'string',  required: true },
      created_at:       { type: 'string',  required: true },
      created_by:       { type: 'string',  required: true },
      updated_at:       { type: 'string',  required: false },
      amount_remaining: { type: 'number',  required: false },
      employee_name:    { type: 'string',  required: false },
      status_label:     { type: 'string',  required: false },
      items:            { type: 'array',   required: false },
    },
  },
  summary_by_employee: {
    type: 'array',
    required: true,
    items: {
      employee_id:     { type: 'string',  required: true },
      employee_name:   { type: 'string',  required: false },
      deduction_count: { type: 'number',  required: true },
      total_remaining: { type: 'number',  required: true },
    },
  },
  total_open:          { type: 'number',  required: true },
  selected_items: {
    type: 'array',
    required: false,
    items: {
      deduction_id:     { type: 'number',  required: true },
      amount:           { type: 'number',  required: true },
      title:            { type: 'string',  required: false },
      employee_id:      { type: 'string',  required: false },
      employee_name:    { type: 'string',  required: false },
      deduction_amount: { type: 'number',  required: true },
    },
  },
})
